"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mustache_1 = __importDefault(require("mustache"));
const siteSearch = {
    processingClickEvent: null,
    init() {
        const self = this;
        const searchTabs = document.querySelectorAll('.js-site-search');
        if (!searchTabs.length)
            return;
        console.log('site-search.init()');
        searchTabs.forEach((tab) => {
            const form = tab.querySelector('[data-search-load-more-form]');
            const submit = form?.querySelector('[type="submit"]');
            if (!form || !submit)
                return false;
            const id = form.getAttribute('data-search-load-more-form');
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                submit.classList.add('loading');
                const formData = new FormData(form);
                const formProps = Object.fromEntries(formData);
                fetch('/stage-ajax/siteSearch/?' + new URLSearchParams(formProps).toString())
                    .then(response => response.json())
                    .then((response) => {
                    if (response.page) {
                        const page = form.querySelector('[name="page"]');
                        if (page) {
                            page.setAttribute('value', response.page + 1);
                        }
                    }
                    if (response.hits) {
                        const template = document.getElementById(`template-search-item-${id}`)?.textContent;
                        const results = document.querySelector(`[data-search-results-container=${id}]`);
                        if (template && results) {
                            const lastChild = results?.lastElementChild;
                            lastChild?.insertAdjacentHTML('afterend', response.hits.map((item) => mustache_1.default.render(template, item)).join(''));
                        }
                    }
                    if (response.total_hits <= response.page * response.limit) {
                        submit.remove();
                    }
                })
                    .catch((err) => {
                    console.error(`Search err error: ${err.message}`);
                });
            });
            tab.addEventListener('click', (e) => {
                const target = e.target.classList.contains('search-result') ? e.target : e.target.closest('.search-result');
                if (target && target.dataset?.searchItem && target.dataset?.searchItemUrl === target.getAttribute('href')) {
                    e.preventDefault();
                    self.sendClickEvent({
                        url: target.getAttribute('href'),
                        id: target.dataset?.searchItem,
                        position: target.dataset?.searchItemPosition,
                        term: target.dataset?.searchItemTerm,
                    });
                    return false;
                }
            });
            return false;
        });
    },
    sendClickEvent(data) {
        if (this.processingClickEvent) {
            return;
        }
        this.processingClickEvent = data.id;
        let locationChanging = false;
        const loadTargetPath = () => {
            if (data.url && !locationChanging) {
                locationChanging = true;
                window.location = data.url;
            }
        };
        try {
            fetch(`/stage-ajax/siteSearch/?stage-language=${document.body.getAttribute('data-language')}&context=reportClick`, {
                method: 'POST',
                body: JSON.stringify({
                    id: data.id,
                    position: parseInt(data.position),
                    term: data.term
                }),
            }).then((res) => {
                loadTargetPath();
            }).catch((err) => {
                loadTargetPath();
            });
            return true;
        }
        catch (err) {
            if (err instanceof Error && err.name !== 'AbortError') {
                console.log(err);
            }
        }
        // Navigate to new url after small delay, even if ajax request has not completed
        setTimeout(loadTargetPath, 500);
    },
};
exports.default = siteSearch;
